import type { SelectOption } from '@/components/Select'
import { ProductSeatType } from '@/types'

// Shown wherever no seat type is chosen and the server falls back to the plan's default.
export const AUTOMATIC_SEAT_TYPE_LABEL = 'Automatic (plan default)'

export const seatTypeLabel: Record<ProductSeatType, string> = {
  [ProductSeatType.Dictation]: 'Dictation only',
  [ProductSeatType.Bundle]: 'Full seat',
  [ProductSeatType.NoAccess]: 'No access',
}

/** The label to show for a person's seat, or undefined when none is recorded or the value is unknown. */
export const seatTypeTitle = (role: string | null | undefined, seatType: string | null | undefined) => {
  // The server always gives IT admins no product, even before a seat is recorded.
  if (role?.toLowerCase() === 'it_admin') return seatTypeLabel[ProductSeatType.NoAccess]

  if (!seatType || !Object.prototype.hasOwnProperty.call(seatTypeLabel, seatType)) return undefined

  return seatTypeLabel[seatType as ProductSeatType]
}

/** Choices for an internal admin picking a new organization's default seat type. */
export const DEFAULT_SEAT_TYPE_OPTIONS: SelectOption[] = [ProductSeatType.Dictation, ProductSeatType.Bundle].map(
  (seatType) => ({ value: seatType, label: seatTypeLabel[seatType] })
)

export const DEFAULT_SEAT_TYPE_HINT =
  "What new members get when their invitation doesn't pick one. Org admins can change it later in Settings."
